import { useContext } from "react";
import { ClinicaContext } from "../../../../context/clinica-context";
import PdfOrcamentoParticular from "./PdfOrcamentoParticular";

const MODELOS = {
  modelo1: PdfOrcamentoParticular,
};

function PdfOrcamentoParticularWrapper({ showSinglePage, orcamentoData }) {
  const { configuracoes } = useContext(ClinicaContext);
  const modeloKey =
    configuracoes?.configuracoes?.modelosDocumentos?.orcamento || "modelo1";
  const Modelo = MODELOS[modeloKey] ?? PdfOrcamentoParticular;

  return (
    <div>
      <Modelo orcamentoData={orcamentoData} showSingleP={showSinglePage} />
    </div>
  );
}

export default PdfOrcamentoParticularWrapper;
